import { render, staticRenderFns } from "./ModelDocForm.vue?vue&type=template&id=33f9d08d"
import script from "./ModelDocForm.vue?vue&type=script&lang=js"
export * from "./ModelDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports